import TableExtended from 'components/TableExtended/TableExtended'

import { getTextWidth as get_text_width } from './utils'

export default TableExtended
export { get_text_width }
export * from './hooks'
export * from './utils'
